module.exports = __webpack_public_path__ + "static/media/LL_BONNIE.e5288d07.webp";